import React, {
    ChangeEvent,
    useContext,
    useEffect,
    useState,
    MouseEvent,
    FormEvent,
} from 'react';
import { useForm } from 'react-hook-form';

import {
    ButtonsWrapper,
    InputWrapper,
    ErrorMsg,
    Input,
    Label,
    Form,
    RechargeSuccess,
    ServerError,
    Overflow,
} from '../ModalsManager.styled';
import { StyledBtnWithSound } from '../../../sounds/StyledBtnWithSound';
import {
    RechargeSigners,
    ServerMessage,
    SignerMessage,
    SocketEmit,
    SocketOn,
    SoundType,
    UserInfo,
    WithdrawSigners,
} from '../../../types.ds';
import { socket } from '../../../server/socket';
import { game } from '../../../store/game';
import { PlayerContext } from '../../../contexts/playerContext';
import { LAMPORTS_PER_SOL, PublicKey } from '@solana/web3.js';
import { updateBalance } from '../../../utils/updateBalance';
import { transactionHandler } from '../../../utils/createTransaction';
import { withdrawBalance } from '../../../utils/withdrawBalance';
import { generateWithDrawSigners } from '../../../utils/generateWithDrawSigners';
import { generateRechargeSigners } from '../../../utils/generateRechargeSigners';
import _ from 'lodash';

interface FormValues {
    balance: number;
}

interface Props {
    modalActive: string
    setModalActive: (actoive: string) => void
}

export const ChatInfoForm = (props: Props) => {
    const onCancel = () => {
        props.setModalActive('');
    };

    const handleHide = () => {
        game.playSound(SoundType.Click);
        game.modalUpdate(true);
    };

    return (
        <Overflow className={props.modalActive} onClick={handleHide}>
            <Form>
                <h3>Chat Rules</h3>
                <p>1. Don't spam, harass or be offensive to other users. Also, avoid using CAPS! No one likes to be screamed at!</p>
                <p>2. Don't beg or ask for loans, rains, tips and doubling coins.</p>
                <p>3. No suspicious behavior that can be seen as potential scams.</p>
                <p>4. Don't engage in any forms of advertising/ trading/ selling/ buying or offering services.</p>
                <p>5. Don't use URL shortener. Always submit the original link.</p>
                <p>6. Use the designated language chatrooms accordingly.</p>
                <p>List of our full rules can be found on our forum.</p>

                <ButtonsWrapper>
                    <StyledBtnWithSound
                        soundType={SoundType.Click}
                        type="button"
                        className="button buttonRed"
                        onClick={onCancel}
                    >
                        Cancel
                    </StyledBtnWithSound>
                </ButtonsWrapper>
            </Form >
        </Overflow >
    );
};
